import ImgQuestion1 from '../../assets/images/modal-question/pregunta-1.png'
import ImgQuestion2 from '../../assets/images/modal-question/pregunta-2.png'
import ImgQuestion3 from '../../assets/images/modal-question/pregunta-1.png'
import ImgQuestion4 from '../../assets/images/modal-question/pregunta-1.png'
import ImgQuestion5 from '../../assets/images/modal-question/pregunta-5.png'

export const GAME_CONFIG = {
  POINTS_PER_BOX_DESTROYED: 3,
  POINTS_PER_QUESTION: 6,
  POINTS_PER_BONUS: 1,
  SPEED: 600,
  BONUS_PER_TIME: 3,
  TIME_BETWEEN_BONUS: 10000,
  ANSWER_TIME: {
    MINUTES: 0,
    SECONDS: 50,
  },
  SHOOTS_PER_BOX: 3,
}

export const QUESTIONS_LIST = [
  {
    id: 1,
    question: '¿Cuántas zonas de absorción tiene la toalla Cur-V?',
    imageUrl: ImgQuestion1,
    answers: [
      {
        id: 'A',
        text: 'Tiene 4 y están distribuidas en la toalla',
        correct: false,
      },
      {
        id: 'B',
        text: 'Tiene las mismas zonas de absorción de todas las toallas',
        correct: false,
      },
      {
        id: 'C',
        text: 'Tiene 3 zonas de absorción inteligente',
        correct: true,
      },
    ],
  },
  {
    id: 2,
    question: '¿Qué es Cur-V?',
    imageUrl: ImgQuestion2,
    answers: [
      {
        id: 'A',
        text: 'Un jabón íntimo con nuevos aromas',
        correct: false,
      },
      {
        id: 'B',
        text: 'Una nueva tecnología de toallas para el día',
        correct: true,
      },
      {
        id: 'C',
        text: 'De poliéster y algodón y fibra de vidrio',
        correct: false,
      },
    ],
  },
  {
    id: 3,
    question: '¿Cuál es la novedad con las alas de esta nueva toalla?',
    imageUrl: ImgQuestion3,
    answers: [
      {
        id: 'A',
        text:
          'Que son asimétricas y abrazan mejor la ropa interior para mayor fijación',
        correct: true,
      },
      {
        id: 'B',
        text: 'Las alas no varían, son iguales',
        correct: false,
      },
      {
        id: 'C',
        text: 'Que son más largas para mayor seguridad',
        correct: false,
      },
    ],
  },
  {
    id: 4,
    question:
      '¿Cómo están distribuidas las zonas de absorción inteligente de esta toalla?',
    imageUrl: ImgQuestion4,
    answers: [
      {
        id: 'A',
        text:
          'Tiene tantas zonas de absorción que están ubicadas a lo largo de la toalla',
        correct: true,
      },
      {
        id: 'B',
        text: 'De poliéster y algodón',
        correct: false,
      },
      {
        id: 'C',
        text: 'Tiene las mismas zonas de absorción de siempre',
        correct: false,
      },
    ],
  },
  {
    id: 5,
    question:
      '¿La tecnología Cur-V se encuentra en todos los productos Nosotras?',
    imageUrl: ImgQuestion5,
    answers: [
      {
        id: 'A',
        text: 'Sí, en todos',
        correct: false,
      },
      {
        id: 'B',
        text: 'En todos los productos Nosotras menos en los jabones íntimos',
        correct: false,
      },
      {
        id: 'C',
        text:
          'En las toallas tipo tela y rapisec, pero no en los productos noche',
        correct: true,
      },
    ],
  },
]
